import isValid from 'date-fns/isValid';
import { BEGINNING_OF_TIME } from '@/lib/constants/dateConstants';

const isFieldValid = (data) => data && data?.value !== '';

const InteractionFieldConfig = {
  selectedDonor: {
    key: 'selectedDonor',
    isValid: isFieldValid,
  },
  selectedDate: {
    key: 'selectedDate',
    isValid: (date) => isValid(date) && date > BEGINNING_OF_TIME,
    isRequired: true,
  },
  interactionMethod: {
    key: 'interactionMethod',
    isValid: isFieldValid,
  },
  narrative: {
    key: 'narrative',
  },
  employeesInvolved: {
    key: 'employeesInvolved',
    isValid: (items) => items.every(isFieldValid),
  },
  experienceRating: {
    key: 'experienceRating',
  },
  // TODO add required validation once API is ready
  campaign: {
    key: 'campaign',
  },
};

export default InteractionFieldConfig;
